export const ACCESS_TYPE_ALL = "ACCESS_TYPE_ALL";